
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.1141',
  depVersions: {
  "portals-platform-reference-fe": "static-1.1141",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.477",
  "foundations-assets": "static-1.4924",
  "foundations-theming": "static-1.4480",
  "foundations-theming-base": "static-1.3465",
  "foundations-theming-specialty": "static-1.2196",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8072",
  "hub-http-shared-msw-handlers": "static-1.10097",
  "hubspot-dlb": "static-2.1854",
  "react-dlb": "static-1.80",
  "data-fetching-client": "static-1.9719",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8036",
  "hub-http": "static-1.6277",
  "HubStyleTokens": "static-2.11528",
  "I18n": "static-7.1633",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1026",
  "quartz-config": "static-1.875",
  "quartz-core": "static-1.6316",
  "quartz-routing": "static-1.527",
  "quick-fetch": "static-1.3959",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16734",
  "rpc-client-utils": "static-1.4707",
  "ui-addon-react-router-dom": "static-1.9596",
  "UIComponents": "static-3.8474",
  "usage-tracker": "static-1.7404",
  "usage-tracker-anonymous": "static-1.5821",
  "usage-tracker-core": "static-1.7254",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3441",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3374",
  "quartz-webpack": "static-1.3321",
  "bend-plugin-quartz-routing": "static-1.175",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.2963",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9478",
  "react-utils": "static-2.5385",
  "StyleGuideUI": "static-3.488",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "quartz": "static-1.7097",
  "hs-test-utils-bend-plugin": "static-1.3183",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "ts-schema": "static-1.4121",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "bend-plugin-foundations-components": "static-1.4305",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2082",
  "ui-fonts": "static-1.790",
  "ui-images": "static-2.1165",
  "hs-locale-management": "static-1.123",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "interframe": "static-3.4814",
  "usage-tracker-multi": "static-1.5818",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4692",
  "icons": "static-2.650",
  "jasmine": "static-4.4380",
  "jasmine-runner": "static-1.6518",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.772",
  "quartz-head": "static-1.762",
  "quartz-i18n": "static-1.772",
  "quartz-test": "static-1.772",
  "quartz-tracking": "static-1.476",
  "trellis-components": "static-1.2101",
  "usage-tracker-container": "static-1.7394",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.117",
  "chirp-fetch": "static-1.1942",
  "cssUtils": "static-1.804",
  "HubStyle": "static-2.11835",
  "bender-build-tools": "static-1.3254",
  "react-input-autosize": "static-2.17",
  "usage-tracker-public": "static-1.7215",
  "sassPrefix": "static-1.157",
  "hubspotter-http-shared-msw-handlers": "static-1.10095",
  "usage-tracker-session-replay": "static-1.5090",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.988",
  "tanstack-virtual": "static-1.31",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.1141",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.477",
  "foundations-assets": "/foundations-assets/static-1.4924",
  "foundations-theming": "/foundations-theming/static-1.4480",
  "foundations-theming-base": "/foundations-theming-base/static-1.3465",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2196",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8072",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10097",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "react-dlb": "/react-dlb/static-1.80",
  "data-fetching-client": "/data-fetching-client/static-1.9719",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8036",
  "hub-http": "/hub-http/static-1.6277",
  "HubStyleTokens": "/HubStyleTokens/static-2.11528",
  "I18n": "/I18n/static-7.1633",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1026",
  "quartz-config": "/quartz-config/static-1.875",
  "quartz-core": "/quartz-core/static-1.6316",
  "quartz-routing": "/quartz-routing/static-1.527",
  "quick-fetch": "/quick-fetch/static-1.3959",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16734",
  "rpc-client-utils": "/rpc-client-utils/static-1.4707",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9596",
  "UIComponents": "/UIComponents/static-3.8474",
  "usage-tracker": "/usage-tracker/static-1.7404",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5821",
  "usage-tracker-core": "/usage-tracker-core/static-1.7254",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3441",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3374",
  "quartz-webpack": "/quartz-webpack/static-1.3321",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.175",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2963",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9478",
  "react-utils": "/react-utils/static-2.5385",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "quartz": "/quartz/static-1.7097",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3183",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "ts-schema": "/ts-schema/static-1.4121",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4305",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2082",
  "ui-fonts": "/ui-fonts/static-1.790",
  "ui-images": "/ui-images/static-2.1165",
  "hs-locale-management": "/hs-locale-management/static-1.123",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "interframe": "/interframe/static-3.4814",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5818",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4692",
  "icons": "/icons/static-2.650",
  "jasmine": "/jasmine/static-4.4380",
  "jasmine-runner": "/jasmine-runner/static-1.6518",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.772",
  "quartz-head": "/quartz-head/static-1.762",
  "quartz-i18n": "/quartz-i18n/static-1.772",
  "quartz-test": "/quartz-test/static-1.772",
  "quartz-tracking": "/quartz-tracking/static-1.476",
  "trellis-components": "/trellis-components/static-1.2101",
  "usage-tracker-container": "/usage-tracker-container/static-1.7394",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.117",
  "chirp-fetch": "/chirp-fetch/static-1.1942",
  "cssUtils": "/cssUtils/static-1.804",
  "HubStyle": "/HubStyle/static-2.11835",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "usage-tracker-public": "/usage-tracker-public/static-1.7215",
  "sassPrefix": "/sassPrefix/static-1.157",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10095",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5090",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.988",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
